import { aequorTheme } from './aequor.theme'
import { crossMedTheme } from './crossMed.theme'

export const THEMES = {
	aequor: aequorTheme,
	crossMed: crossMedTheme,
}
